import Vue from 'vue'
import Router from 'vue-router'
import _interceptor from './_interceptor'
const { isNavigationFailure, NavigationFailureType } = Router
import store from '@/store'

const pushSuper = Router.prototype.push
Router.prototype.push = function (location) {
  return pushSuper.call(this, location).catch((err) => {
    if (err.name !== 'NavigationDuplicated') {
      store.dispatch('time/refresh')
      throw err
    }
  })
}

const replaceSuper = Router.prototype.replace
Router.prototype.replace = function (location) {
  return replaceSuper.call(this, location).catch((err) => {
    if (err.name !== 'NavigationDuplicated') {
      store.dispatch('time/refresh')
      throw err
    }
  })
}

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => {
    if (isNavigationFailure(err, NavigationFailureType.cancelled)) {
      console.log(err, 'NavigationFailureType.cancelled')
      return
    }
    // if (err === undefined || err === false) {
    //   // next('/other') next(false) 고려..
    //   // console.log(err, 'location')
    //   Vue.config.errorHandler(err)
    // } else {
    //   // console.error(err, 'location')
    //   Vue.config.errorHandler(err)
    // }
    Vue.config.errorHandler(err)
  })
}

const routers = [
  require('./apply'),
  require('./bank'),
  require('./callback'),
  require('./documents'), // 서류 제출
  require('./error'),
  require('./factoring'),
  require('./find'),
  require('./guide'),
  require('./kyc'), // KCB Callback url
  require('./landing'),
  require('./main'),
  require('./settlement'),
  require('./signin'),
  require('./signout'),
  require('./signup'),
  require('./terms'),
  require('./test'),
  require('./update'),
  require('./loan'),
  require('./auth'),
  require('./credit-pay'),
  require('./woori-crowd'),
  require('./compare-loans'),
  require('./aicrm'), // AI CRM 서비스
  require('./marketing-store'), // 우수 마케팅 매장 인증제도
]

Vue.use(Router)

let mergeRouters = []
routers.forEach((route) => {
  mergeRouters = mergeRouters.concat(route.default)
})

const vueRouter = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: mergeRouters,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

_interceptor.forEach((f) => {
  vueRouter.beforeEach(f.default)
})

vueRouter.afterEach((to, from) => {
  window?.dataLayer?.push({ contentViewName: to?.name, prevContentViewName: from?.name })
})

export default vueRouter
